/* global G */
/* eslint-disable object-curly-newline,arrow-body-style,no-unused-vars */
import stepper from 'app/_shared/action/stepper'
import { asyncPipeSpread, setKey } from 'lib/util'
import find from 'lib/sequence/component/children/find'
import sequenceComponentState from 'lib/sequence/component/state'
import seqModelRead from 'lib/sequence/model/api/read'
import { CONFIRM } from 'app/_shared/events/setStepTab'
import organisation from './create/organisation'
import contact from './create/contact'

const {
  set: setTab,
} = sequenceComponentState('activeTab')

const setConfirmTab = step => setTab(step, CONFIRM)

/**
 * Presets the item step if available.
 *
 * @param {Gaia.AppModule.Spec} module  the current module composition object
 * @returns {function(*): function(...[*]): Promise<*[]>}
 */
export const presetLocation = module => component => async (components, ...args) => {
  const { organisation: targetOrganisation } = args[0] || {}

  if (targetOrganisation) {
    const model = module[G.MODEL]
    model[G.CHILDREN].organisation[G.CACHE] = targetOrganisation[G.CACHE]
    model[G.CHILDREN].organisation[G.STATE][G.REF] = targetOrganisation[G.STATE][G.REF]

    await seqModelRead(model[G.CHILDREN].organisation)(component)

    setConfirmTab(components.organisation)
  }

  return [components, ...args]
}
/**
 * Gathers the actions for the stepper.
 *
 * @param {Gaia.AppModule.Spec} module  the current module composition object
 * @returns {function(*): function(...[*]): Promise<*[]>}
 */
const initActions = module => component => async (...args) => [
  { organisation, contact }, args,
]

/**
 * Initializes the stepper.
 *
 * @param {Gaia.AppModule.Spec} module  the current module composition object
 * @returns {function(*): function(...[*]): Promise<*[]>}
 */
const initStepper = module => component => async (actions, ...args) => {
  return stepper(module)(component)({ actions, ...args })
}

export default module => component => async (...args) => asyncPipeSpread(
  presetLocation(module)(component),
  initActions(module)(component),
  initStepper(module)(component),
)(find(component), ...args)
